import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Card, Table, Badge, Button, InputGroup } from 'react-bootstrap';
import Select from "react-select";
import { useCampaign } from '../CampaignContext';

const Step2Audience = () => {
    const { state, dispatch } = useCampaign();
    const { audience } = state;
    const [searchQuery, setSearchQuery] = useState('');

    // Mock tags (should be fetched from API in real implementation)
    const [tagOptions] = useState([
        { value: '1', label: 'Registered' },
        { value: '2', label: 'Interested' },
        { value: '3', label: 'Potential' },
        { value: '4', label: 'Follow-up Required' }
    ]);

    // Mock user data matching the logic
    const [users] = useState([
        { id: 1, name: 'John Doe', mobile: '918888888888', email: 'john@example.com' },
        { id: 2, name: 'Jane Smith', mobile: '919999999999', email: 'jane@example.com' },
        { id: 3, name: 'Alice Walker', mobile: '917777777777', email: 'alice@example.com' },
        { id: 4, name: 'Bob Johnson', mobile: '916666666666', email: 'bob@example.com' }
    ]);

    const handleIncludeTagsChange = (selected) => {
        dispatch({ type: 'UPDATE_AUDIENCE', payload: { includeTags: selected || [] } });
    };

    const handleExcludeTagsChange = (selected) => {
        dispatch({ type: 'UPDATE_AUDIENCE', payload: { excludeTags: selected || [] } });
    };

    return (
        <div className="py-2">
            <h5 className="font-weight-bold mb-3">Define Target Audience</h5>
            <p className="text-muted small mb-4">
                Include or exclude users based on their tags and preview the recipient list.
            </p>

            <Row className="mb-4">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="small font-weight-bold">INCLUDE TAGS</Form.Label>
                        <Select 
                            isMulti
                            options={tagOptions}
                            value={audience.includeTags}
                            onChange={handleIncludeTagsChange}
                            placeholder="Select tags to include..."
                            className="basic-multi-select shadow-sm"
                            classNamePrefix="select"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="small font-weight-bold">EXCLUDE TAGS</Form.Label>
                        <Select 
                            isMulti
                            options={tagOptions}
                            value={audience.excludeTags}
                            onChange={handleExcludeTagsChange}
                            placeholder="Select tags to exclude..."
                            className="basic-multi-select shadow-sm text-danger"
                            classNamePrefix="select"
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Card className="border shadow-sm overflow-hidden bg-white">
                <Card.Header className="bg-light border-bottom py-3 d-flex justify-content-between align-items-center">
                    <h6 className="m-0 font-weight-bold text-dark">MATCHING USERS (4 Found)</h6>
                    <InputGroup style={{ width: '250px' }}>
                        <Form.Control 
                            size="sm" 
                            placeholder="Find in results..." 
                            className="wcm-search-small"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </InputGroup>
                </Card.Header>
                <Card.Body className="p-0" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                    <Table responsive hover size="sm" className="mb-0 bg-white">
                        <thead className="bg-light text-muted small">
                            <tr>
                                <th className="px-3">#</th>
                                <th>NAME</th>
                                <th>MOBILE</th>
                                <th>EMAIL</th>
                            </tr>
                        </thead>
                        <tbody className="small">
                            {users.map((user, idx) => (
                                <tr key={user.id}>
                                    <td className="px-3 py-2 text-muted">{idx + 1}</td>
                                    <td className="font-weight-bold">{user.name}</td>
                                    <td>{user.mobile}</td>
                                    <td className="text-muted">{user.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
                <Card.Footer className="bg-white text-center py-2">
                    <p className="m-0 small text-muted">
                        Total Audience Size: <strong className="text-primary">4 Recipients</strong>
                    </p>
                </Card.Footer>
            </Card>
        </div>
    );
};

export default Step2Audience;
